import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';
import { LINK_PROP_TYPE, LINKS_PROP_TYPE } from '@eb/eds-global-header';

export { LINK_PROP_TYPE, LINKS_PROP_TYPE };
export const SECTION_PROP_TYPE = PropTypes.shape({
    title: translationPropType,
    links: LINKS_PROP_TYPE,
});
export const SECTIONS_PROP_TYPE = PropTypes.arrayOf(SECTION_PROP_TYPE);
